import React from 'react';
import Image from '~/components/Dynamic/Image';
import { Link } from 'gatsby';
import PostPreviewText from '~/components/PostPreviewText';
import renderLink from '~/utils/render-link';
export default function PressPreview({ post, className = '', align = 'left', imageWidth = 180, imageClasses = 'aspect-w-3 aspect-h-3' }) {
  return (
    <Link to={renderLink(post.content.link)} className={`block hover:opacity-90 transition-opacity duration-200 group ${className}`}>
      <div className={`md:flex flex-wrap md:flex-nowrap -ml-10 ${align === 'center' && 'md:justify-center'}`}>
        <div style={{ flex: `0 0 ${imageWidth + 'px'}` }} className="pl-10 mb-4 mr-0 md:mb-0 md:mr-auto">
          <div className={`${imageClasses}`}>
            <div className="overflow-hidden">
              <div className="w-full h-full transition-transform duration-500 transform group-hover:scale-105">
                <Image blok={post.content.image} className="object-cover w-full h-full"/>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center w-full pl-10 md:w-auto">
          <div className="sm:max-w-sm">
            <PostPreviewText post={post} customCategory="Press"/>
          </div>
        </div>
      </div>
    </Link>
  );
}
